/**
 * @generated SignedSource<<cf6794cdb70d8222a9918d8bb0141ad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_displayInfo";
};
export type PdpRespMarketplaceStickyHeader_displayInfo$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "7f90c73abdd6f8a3560aa4227d1ec33e";

export default node;
